import React, { useState } from "react";
import {
  Outlet,
  createBrowserRouter,
  Navigate
} from "react-router-dom";

// import Index1 from "./pages/Index1/Index1";
// import Index2 from "./pages/Index2/Index2";
// import Index3 from "./pages/Index3/Index3";
// import Index4 from "./pages/Index4/Index4";
// import Index5 from "./pages/Index5/Index5";
// import Index6 from "./pages/Index6/Index6";
// import Index7 from "./pages/Index7/Index7";
// import Index8 from "./pages/Index8/Index8";
// import Index9 from "./pages/Index9/Index9";

//Auth Pages
// import Signup from "./pages/Auth/Signup";
// import Login from "./pages/Auth/Login";
// import PasswordForget from "./pages/Auth/PasswordForget";

//custom pages
import QuoranList from "./pages/QuranList/QuranList";
import NavbarPage from "./components/Navbar/Navbar_Page";
import Footer from "./components/Footer/footer";
import QuoranComponent from "./pages/Quran/QuranComponent";
import SurahInformation from "./pages/SurahInformation/SurahInformation";
import SajdahPlaces from "./pages/SajdahPlaces/SajdahPlaces";
import JuzBreakdown from "./pages/JuzBreakDown/JuzBreakDown";
import PrintSurah from "./pages/PrintSurah/PrintSurah";
import AboutUs from "./components/AboutUs/AboutUs";
import ContactUs from "./components/Contact/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";


export const Layout = () => {
  const [state] = useState({
    navItems: [
      { id: 1, idnm: "home", navheading: "Home", link: "/surah-list" },
      { id: 2, idnm: "surahs_1_60", navheading: "Surahs 1-60", subMenu: true, start:1, stop:60 },
      { id: 3, idnm: "surahs_61_114", navheading: "Surahs 61-114", subMenu: true, start: 61, stop:114 },
      { id: 4, idnm: "resources", navheading: "Resources", subMenu: true, custom: true, customMenuItem: [
        {
          name: "Surah Info",
          link: "/surah-information"
        },
        {
          name: "Sajdah Places",
          link: "/sajdah-places"
        },
        {
          name: "Juz BreakDown",
          link: "/juz-breakdown"
        },
        {
          name: "Print Surah",
          link: "/make-pdf-surah"
        }
      ] },
      { id: 5, idnm: "contact-us", navheading: "Contact Us", link: "/contact-us" },
      { id: 6, idnm: "about", navheading: "About Us", link: "/about-us" }
    ],
    navClass: "",
  });
  
  return (
    <>
      <NavbarPage navItems={state.navItems} navClass={state.navClass} />
      <Outlet />
      <Footer />
    </>
  );
};

const routes = [
  // { path: "/password-forget", component: <PasswordForget />},
  // { path: "/login", component: <Login />},
  // { path: "/sign-up", component: <Signup />},

  // { path: "/home-nine", component: <Index9 /> },
  // { path: "/home-eight", component: <Index8 /> },
  // { path: "/home-seven", component: <Index7 /> },
  // { path: "/home-six", component: <Index6 /> },
  // { path: "/home-five", component: <Index5 /> },
  // { path: "/home-four", component: <Index4 /> },
  // { path: "/home-three", component: <Index3 /> },
  // { path: "/home-two", component: <Index2 /> },
  // { path: "/home-one", component: <Index1 /> },
  { path: "/about-us", component: <AboutUs /> },
  { path: "/contact-us", component: <ContactUs /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/surah-list/:surahId", component: <QuoranComponent /> },
  { path: "/surah-list", component: <QuoranList /> },
  { path: "/surah-information" , component: <SurahInformation /> },
  { path: "/sajdah-places" , component: <SajdahPlaces /> },
  { path: "/juz-breakdown", component: <JuzBreakdown /> },
  { path: "/make-pdf-surah", component: <PrintSurah />},
  {
    path: "/",
    component: <Navigate to="/surah-list" />,
  }
];

const router = createBrowserRouter([
  ...(routes || []).map((route) => ({
    ...(!route.commonScreen && { element: <Layout /> }),
    children: [
      {
        path: route.path,
        element: route.component,
      },
    ]
  }))
])

export default router;
